import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-quantity-minus",
  "use": "icon-quantity-minus-usage",
  "viewBox": "0 0 4 2",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 4 2\" id=\"icon-quantity-minus\"><path d=\"M0-.001h3.432v1.265H0V-.001Z\" fill=\"#003C71\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol